function copyDataToClipboard(copyable: string) {
    const textarea = document.createElement("textarea");
    textarea.style.outline = "none";
    textarea.style.boxShadow = "none";
    textarea.style.background = "transparent";
    textarea.value = copyable;
    const focusedElement = document.activeElement as HTMLElement;
    const oldScrollPos = window.pageYOffset;
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand("copy");
    } finally {
        document.body.removeChild(textarea);
        if (oldScrollPos) {
            window.scroll(window.pageXOffset, oldScrollPos);
        }
        focusedElement.focus();
    }
}

export { copyDataToClipboard };
